import { Button } from "antd";
import React, { useState } from "react";

import { StartIcon } from "../icon/icon.jsx";
import { FlightViewModal } from "./FlightViewModal.jsx";

import { $t } from "~/i18n.js";

export const FlightOpenIcon = ({
  flight_uuid = null,
  flight_object = null,
  icon = null,
  buttonProps = {},
  hideTextOnMobile = false,
  showLedgers = false,
}) => {
  const [showFlight, setShow] = useState(false);

  const width = window?.innerWidth < 500

  return (
    <>
      {showFlight && (
        <FlightViewModal
          onClose={() => setShow(false)}
          flight_uuid={flight_uuid}
          flight_object={flight_object}
          currentUser={null}
          updateFlight={null}
          onUpdateFlight={null}
          showLedgers={showLedgers}
        />
      )}

      <Button
        className="flight-open-icon"
        type="text"
        icon={icon || <StartIcon />}
        size="small"
        {...buttonProps}
        onClick={(e) => {
          setShow(true)
          e.stopPropagation()
        }}
      >
        <small
          style={
            hideTextOnMobile
              ? {
                  display: width ? "none" : "inline",
                }
              : undefined
          }
        >
          {$t('Bekijk vlucht')}
        </small>
      </Button>
    </>
  );
};
